let locales = {
    statusChangesHistory_title:  "Historial de cambios",
}

export default locales;